import { GetTheIdoButtonSearchResultsQueryReturn } from 'src/models/ido';

import { Callback } from 'src/util/query/models/Callback';

import { SetIdoButtonSearchReturnPayload } from '../interfaces';

export class GetTheIdoButtonSearchResultsQueryCallback extends Callback<GetTheIdoButtonSearchResultsQueryReturn[]> {
	public constructor(
		private readonly aggregateId: string,
		private readonly setIdoButtonSearchReturn: (payload: SetIdoButtonSearchReturnPayload) => void
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: GetTheIdoButtonSearchResultsQueryReturn[]): void => {
		this.setIdoButtonSearchReturn({
			aggregateId: this.aggregateId,
			idoButtonSearchResults: successResponse,
		});
	};
}
